import { VSelect } from "vuetify/components";
import { pricingModels, props } from "./common";

export default defineComponent({
  props,
  render() {
    return h(VSelect, {
      ...this.$attrs,
      class: "complex-pricing complex-pricing__select",
      readonly: this.readonly,
      disabled: this.disabled,
      density: this.density,
      hideDetails: true,
      items: pricingModels,
      modelValue: this.modelValue,
    });
  },
});
